import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { convertToDevanagari } from "../helpers/utility";

const Home = () => {
 
  return (
    <>
      <section className='hero'>
        <Container>
          <Row className='align-items-center'>
            <Col md='2'>
              <img
                src='https://lingayatyavatmal.com/assets/img/basweshwar.png'
                className='vh_mahatma'
                alt='जगद्ज्योती महात्मा बसवेश्‍वर'
              />
              <p className='vh_m_text'>जगद्ज्योती महात्मा बसवेश्‍वर</p>
            </Col>
            <Col md='6'>
              <p className='vh-fancy'>वीरशैव हितसंवर्धक मंडळ, यवतमाळ द्वारा</p>
              <h2>आंतरराज्यीय लिंगायत समाज वधु-वर परिचय मेळावा {convertToDevanagari(new Date().getFullYear())}</h2>
              <p>
                मेळावा: <span style={{ fontWeight: 'bold' }}>रविवार दि.२२ नोव्हेंबर २०२६</span>, स्थळ: महात्मा बसवेश्वर
                सांस्कृतीक भवन, लोहारा, यवतमाळ
              </p>
              <p>
                मेळावा फॉर्म भरण्याची अंतिम तारीख <span style={{ fontWeight: 'bold' }}>३१ आक्टोंबर, २०२६</span>.
              </p>
              <p style={{ fontWeight: 'bold' }}>
                मेळावा ऑफलाईन पध्दतीने होत असुन माहीती पुस्तिका मेळाव्याच्या दिवशीच देण्यात येईल, त्यामुळे ३१ आक्टोंबर
                अगोदर नोंदणी करणे आवश्यक आहे.
              </p>
              <Link to='/register' className='btn btn-light'>
                आताच नोंदणी करा
              </Link>
            </Col>
            <Col md='4'>
              <img src='https://lingayatyavatmal.com/assets/img/couple.png' className='img-fluid' alt='couple' />
            </Col>
          </Row>
        </Container>
      </section>

      <section className='about-event'>
        <Container>
          <Row className='justify-content-center'>
            <Col md='9'>
              <h2 className='section-title'>मेळाव्याबद्दल...</h2>
              <p>
                १९९१ पासून वधुवर परिचय मेळाव्याच्या आयोजनाची परंपरा आजतागायत सुरु आहे. कोरोनाच्या काळातही २९ नोव्हे.
                २०२० ला इंटरनेटच्या माध्यमातून महाराष्ट्रातील पहिला ऑनलाईन वधुवर परिचय होऊन वधुवरांची सूची असलेली
                स्मरणिकाही प्रकाशित करण्यात आली. ह्या नविन पध्दतीला समाज बांधवानी अक्षरश: उचलुन घेत अद्भुत प्रतिसाद दिला
                त्या जोरावरच वीरशैव हितसंवर्धक मंडळाने महाराष्ट्रातील एकमेव आकर्षक अशी माहीती पुस्तिका मेळाव्याच्या
                दिवशीच प्रकाशीत केली, दरवर्षी मेळाव्याद्वारे ५०% च्या वर हमखास लग्ण जुळतातच हा सर्वांचा अनुभव आहे.
              </p>
              <p>
                मंडळ दरवर्षी जेष्ठ नागरिकांचा सत्कार, गुणवंत विद्यार्थी सत्कार, महात्मा बसवेश्वर जयंती, उत्सव, निशुल्क
                आरोग्य तपासणी शिबीर, महिला मंडळाच्या सांस्कृतिक स्पर्धा, संक्रांती उत्सव, पाडवा पहाट इ. कार्यक्रमाचे
                आयोजन दरवर्षी होत असते. तसेच, वीरशैव हितसंवर्धक मंडळ व वसुधा प्रतिष्ठान द्वारा दरवर्षी प्रतिष्ठेचा
                वीरशैव लिंगायत महाराष्ट्र भुषण, समाज भुषण, आणि महिलांचा सन्मान करतांना अक्कमहादेवी मायमाऊली पुरस्कार
                प्रदान करण्यात येतो. मागील वर्षी २०२१ मध्ये मंडळाने वधुवर परिचय मेळाव्या करिता डिजीटल युगात एक पाऊल पुढे
                टाकत अद्यावत अशी{' '}
                <a href='https://lingayatyavatmal.com/' style={{ fontSize: '1.1rem' }}>
                  lingayatyavatmal.com
                </a>{' '}
                ह्या वेबसाईट ची निर्मिती केली, ह्यामुळे उप वधु-वरांना फॉर्म भरणे अधिकच सोईचे झाले आहे, ह्या वर्षीच्या
                वधुवर परिचय मेळाव्यात सहभागी होणार्‍या विवाहेच्छूक युवक-युवतींना भावी वैवाहिक आयुष्याच्या जोडिदाराच्या
                निवडीसाठी हार्दिक शुभेच्छा!
              </p>
              {/* <p>
                <b>आयोजक</b>
                <br />
                <b>वीरशैव हितसंवर्धक मंडळ, यवतमाळ</b>
                <br />
                मा.श्री.डॉ. जयेश पु. हातगावकर, अध्यक्ष,
                <br />
                मा.श्री.डॉ. किशोर ओ. मांडगावकर, उपाध्यक्ष
                <br />
                मा.श्री. निलेश वि. शेटे, सचिव
                <br />
                मा.श्री. गिरीष सु. गाढवे, कोषाध्यक्ष
                <br />
                मा.श्री. गजानन हातगावकर,सह सचिव
                <br />
                <br />
                <b>कार्यकारीणी सदस्य</b>
                <br />
                मा.श्री. रमेशराव केळकर,
                <br />
                मा.श्री. नागेश कुल्ली,
                <br />
                मा.श्री. राजु कुर्हेकार,
                <br />
                मा.श्री. भुषण तंबाखे,
                <br />
                मा.श्री. विनोद देशमुख,
                <br />
                मा.श्री. जयंत डोंगरे
              </p> */}
              <p>
                <b>आयोजक</b>
                <br />
                <b>वीरशैव हितसंवर्धक मंडळ, यवतमाळ</b>
                <br />
                मा.श्री. जयेश पुरूषोत्तम हातगांवकर अध्यक्ष
                <br />
                मा.श्री. गिरीष सुधाकरराव गाढवे, उपाध्यक्ष
                <br />
                मा.श्री. निलेश विश्वनाथ शेटे, सचिव
                <br />
                मा.श्री. गजानन शामरावजी हातगांवकर, सहसचिव
                <br />
                मा.श्री. विनोद शंकरराव नारिंगे, कोषाध्यक्ष
                <br />
                <br />
                <b>कार्यकारीणी सदस्य</b>
                <br />
                मा.श्री. रमेशराव केळकर,
                <br />
                मा.श्री. विनोद हरिभाऊ देशमुख,
                <br />
                मा.श्री. जयंत दिगांबर डोंगरे,
                <br />
                मा.श्री. निर्मल बळवंतराव ठोंबरे,
                <br />
                मा.श्री. महेंद्र शंकरराव ठोंबरे,
                <br />
                मा.श्री. संजय त्र्यंबकराव खारपाटे
              </p>
              <Link to='/about' className='btn btn-danger'>
                अधिक जाणून घ्या
              </Link>
              {/* <img
                src="https://lingayatyavatmal.com/assets/img/resim.jpg"
                className="img-fluid"
              /> */}
            </Col>
          </Row>
        </Container>
      </section>

      <section className='vh_ad'>
        <Container>
          <Row className='justify-content-center'>
            <Col md='9'>
              <h2 className='section-title'>मेळावा पुस्तिका मध्ये जाहिराती करिता संपर्क</h2>
              <p>
                डॉ.जयेश हातगावकर: ९४२२१६७५३६
                <br />
                निलेश विश्वनाथ शेटे: ९३७२६१२२७०
                <br />
                गिरीष सुधाकरराव गाढवे: ९४२२९२१५५७
                <br />
                डॉ.प्रा.किशोर ओ.मांडगावकर: ७७७४८७४४४४
                <br />
                सुरेश सो. शेटे: ९६०४१५३९७७
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='the-process'>
        <Container>
          <Row>
            <Col md='12'>
              <h2 className='section-title text-center'>नोंदणी प्रक्रिया</h2>
              <img src='https://lingayatyavatmal.com/assets/img/separator.png' className='separator' alt='' />
            </Col>
            <Col md='4' className='mb-3 mb-md-0'>
              <div className='process-container'>
                <div className='digit'>१</div>
                <h3>ऑनलाईन नोंदणी करा</h3>
              </div>
            </Col>
            <Col md='4' className='mb-3 mb-md-0'>
              <div className='process-container'>
                <div className='digit'>२</div>
                <h3>ऑनलाईन पेमेंट करा</h3>
              </div>
            </Col>
            <Col md='4'>
              <div className='process-container'>
                <div className='digit'>३</div>
                <h3>घरपोच पुस्तिका मिळवा</h3>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='presidents-message'>
        <Container>
          <Row className='justify-content-center'>
            {/* <Col md="4">
            <h4 className="section-title text-center">
            आमचे प्रेरणास्थान
              </h4>
            <img
                src="https://lingayatyavatmal.com/assets/img/gadhave.jpg"
                className="img-fluid mb-3 mb-md-0"
              />
              <p className="text-center"><b>दानशूर लिंगैक्य लहानुआप्पा भगवानआप्पा गाढवे</b></p>
            </Col> */}
            <Col md='6'>
              <h4 className='section-title text-center'>आमचे आधारस्तंभ</h4>
              <p className='text-center'>
                <b>वीरशैव लिंगायत विदर्भ रत्न पुरस्कार प्राप्त</b>
              </p>
              <img
                src='https://lingayatyavatmal.com/assets/img/adhar.jpg'
                className='img-fluid mb-3 mb-md-0'
                alt='लिंगैक्य सुधाकरआप्पा गाढवे'
              />
              <p className='text-center'>
                <b>
                  लिंगैक्य सुधाकरआप्पा गाढवे
                  <br />
                  यवतमाळ
                </b>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='cta'>
        <Container>
          <Row className='justify-content-center'>
            <Col md='8' className='text-center'>
              <h2 className='section-title text-white mb-2'>हे बंध रेशमाचे!</h2>
              <Link to='/register' className='btn btn-warning mx-auto'>
                आताच नोंदणी करा
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
